<template>
  <TransitionRoot
    :show="isOpen"
    as="template"
    enter="duration-300 ease-out"
    enter-from="opacity-0 scale-95"
    enter-to="opacity-100 scale-100"
    leave="duration-200 ease-in"
    leave-from="opacity-100 scale-100"
    leave-to="opacity-0 scale-95">
    <div
      class="cookie-notice fixed bottom-0 left-1/2 z-50 flex max-h-[60%] min-h-[152px] w-full max-w-[740px] -translate-x-1/2 flex-wrap gap-4 overflow-auto rounded-3xl bg-white p-6 shadow-even2xl md:bottom-6"
      data-lenis-prevent>
      <h2 class="w-full text-2xl">About cookies</h2>
      <div class="flex flex-col items-end gap-4 md:flex-row md:items-start md:gap-6">
        <p class="w-auto font-normal text-gray-300">
          This website uses cookies for the display of the website and its features. Please see more information about
          cookies used in our
          <NuxtLink
            href="/cookies/"
            class="font-medium underline">
            Cookie Policy </NuxtLink
          >.
        </p>
        <CookieButton
          label="Ok"
          @click="handleConfirmButtonClick()" />
      </div>
    </div>
  </TransitionRoot>
</template>

<script setup lang="ts">
  import { TransitionRoot } from '@headlessui/vue'

  const { setCookiesConsent } = useCookiesConsent()
  const isOpen = ref(false)

  function open() {
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
  }

  function handleConfirmButtonClick() {
    setCookiesConsent()
    close()
  }

  onMounted(() => {
    open()
  })
</script>
